<template>
  <div class="widget-wrapper">
    <fieldset v-on:input="$emit('input', $event.target.value)">
      <legend>{{ label }}</legend>
      <label v-for="(item, i) in values" v-bind:key="item">
        <input
          type="radio"
          v-bind:name="name"
          v-bind:value="item"
          v-bind:checked="item === value"
        />
        {{ names[i] }}
      </label>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: 'RingsCalculatorRadio',
  props: {
    value: { type: String },
    name: { type: String },
    label: { type: String },
    names: { type: Array },
    values: { type: Array }
  },
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .widget-wrapper > fieldset {
    display: block;
    text-align: left;
    padding: 0;
    border: 0;
    margin-left: 0;
    margin-right: 0;

    & > legend {
      display: block;
      text-align: left;
      text-transform: uppercase;
      font-family: "Gotham Pro Regular", $font-stack;
      color: $default-heading-color;
      padding-bottom: 0.5em;
    }
    & > label {
      display: block;
      margin-right: 0.5em;
      padding: 0.33em 0 0.33em 0;
      cursor: pointer;
      font-size: 13px !important;

      &:last-child { margin-right: 0; }

      & > input[type="radio"] {
        appearance: none;
        border-radius: 50%;
        width: 1em;
        height: 1em;
        border: 0.125em solid $default-text-color;
        transition: 0.2s all linear;
        outline: none;
        margin-right: 0.33em;
        position: relative;
        top: 2px;
        &:checked {
          background-color: $default-link-color;
          border: 0.25em solid $default-text-color;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/RingsCalculatorInputRadio.vue